import React, { useState, useEffect } from 'react';
import { getRandomAd } from './adConfig';
import './AdBanner.css';

const AdBanner = ({ className = '' }) => {
  const [adData, setAdData] = useState(null);

  useEffect(() => {
    // コンポーネントマウント時にランダムな広告を選択
    const selectedAd = getRandomAd();
    setAdData(selectedAd);
  }, []);

  if (!adData) {
    return (
      <div className={`ad-banner ${className}`}>
        <div className="ad-loading">広告を読み込み中...</div>
      </div>
    );
  }

  return (
    <div className={`ad-banner ${className}`}>
      <div className="ad-content">
        <a href={adData.linkUrl} rel="nofollow sponsored noopener" target="_blank">
          <img
            border="0"
            width={adData.width}
            height={adData.height}
            alt={adData.name}
            src={adData.imageUrl}
            loading="lazy"
          />
        </a>
        {adData.trackingUrl && (
          <img
            border="0"
            width="1"
            height="1"
            src={adData.trackingUrl}
            alt=""
            style={{ display: 'none' }}
          />
        )}
      </div>
    </div>
  );
};

export default AdBanner;